import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { zhTW, zhCN, en, ja, ko, th, vi } from './lang';

Vue.use(VueI18n);

const SUPPORTED_LOCALES = ['zh-TW', 'zh-CN', 'en', 'ja', 'ko', 'th', 'vi'];

const messages = {
  'zh-TW': zhTW,
  'zh-CN': zhCN,
  en,
  ja,
  ko,
  th,
  vi
};

const LOCALE_TO_HTML = {
  'zh-TW': 'zh-TW',
  'zh-CN': 'zh-CN',
  en: 'en',
  ja: 'ja',
  ko: 'ko',
  th: 'th',
  vi: 'vi'
};

const LOCALE_TO_MOMENT = {
  'zh-TW': 'zh-tw',
  'zh-CN': 'zh-cn',
  en: 'en',
  ja: 'ja',
  ko: 'ko',
  th: 'th',
  vi: 'vi'
};

function loadStoredLocale() {
  const stored = localStorage.getItem('payvault_locale');
  if (SUPPORTED_LOCALES.includes(stored)) {
    return stored;
  }
  const lang = navigator.language || navigator.userLanguage || '';
  const lower = lang.toLowerCase();
  if (lower.startsWith('zh-tw')) return 'zh-TW';
  if (lower.startsWith('zh-cn') || lower === 'zh') return 'zh-CN';
  if (lower.startsWith('en')) return 'en';
  if (lower.startsWith('ja')) return 'ja';
  if (lower.startsWith('ko')) return 'ko';
  if (lower.startsWith('th')) return 'th';
  if (lower.startsWith('vi')) return 'vi';
  return 'zh-TW';
}

const initialLocale = loadStoredLocale();

export const i18n = new VueI18n({
  locale: initialLocale,
  fallbackLocale: 'zh-TW',
  messages
});

export async function setLocale(locale) {
  if (!SUPPORTED_LOCALES.includes(locale)) return;
  i18n.locale = locale;
  localStorage.setItem('payvault_locale', locale);
  document.documentElement.lang = LOCALE_TO_HTML[locale] || 'zh-TW';
  const momentLocale = LOCALE_TO_MOMENT[locale] || 'zh-tw';
  const moment = (await import('moment')).default;
  // moment 預設為 en，無 moment/locale/en.js 檔案，故跳過載入
  if (momentLocale !== 'en') {
    await import(`moment/locale/${momentLocale}`);
  }
  moment.locale(momentLocale);
}
